import { CalendarEvent, EventType, EventSourceType } from '../models/dashboard-stats.model';

export const MOCK_DASHBOARD_CALENDAR_EVENTS: CalendarEvent[] = [
  {
    id: 1,
    titleKey: 'calendar.building-inspection',
    title: 'calendar.building-inspection',
    date: new Date('2024-08-20T09:00:00'),
    type: EventType.MAINTENANCE,
    descriptionKey: 'calendar.building-inspection-description',
    description: 'calendar.building-inspection-description',
    color: '#ff9800',
    sourceType: EventSourceType.MAINTENANCE,
    sourceId: 1,
    startTime: new Date('2024-08-20T09:00:00'),
    endTime: new Date('2024-08-20T17:00:00'),
    locationKey: 'calendar.building',
    location: 'calendar.building',
    isAllDay: false,
  },
  {
    id: 2,
    titleKey: 'calendar.resident-meeting',
    title: 'calendar.resident-meeting',
    date: new Date('2024-08-22T18:00:00'),
    type: EventType.MEETING,
    descriptionKey: 'calendar.resident-meeting-description',
    description: 'calendar.resident-meeting-description',
    color: '#2196f3',
    sourceType: EventSourceType.ANNOUNCEMENT,
    sourceId: 2,
    startTime: new Date('2024-08-22T18:00:00'),
    endTime: new Date('2024-08-22T20:00:00'),
    locationKey: 'calendar.community-hall',
    location: 'calendar.community-hall',
    isAllDay: false,
  },
  {
    id: 3,
    titleKey: 'calendar.gym-equipment-maintenance',
    title: 'calendar.gym-equipment-maintenance',
    date: new Date('2024-08-25T10:00:00'),
    type: EventType.MAINTENANCE,
    descriptionKey: 'calendar.gym-equipment-maintenance-description',
    description: 'calendar.gym-equipment-maintenance-description',
    color: '#f44336',
    sourceType: EventSourceType.MAINTENANCE,
    sourceId: 3,
    startTime: new Date('2024-08-25T10:00:00'),
    endTime: new Date('2024-08-25T16:00:00'),
    locationKey: 'calendar.gym',
    location: 'calendar.gym',
    isAllDay: false,
  },
];
